import { render, staticRenderFns } from "./Observer.vue?vue&type=template&id=15349bd0"
import script from "./Observer.vue?vue&type=script&lang=ts"
export * from "./Observer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports